<script lang="ts">
  import type { Seminar } from './types';
  import SeminarTile from './SeminarTile.svelte';
  import { splitSeminarsByDayAndTime } from './utils/helpers'
  type Props = {
    seminars: Seminar[];
  };

  const { seminars }: Props = $props();

  const seminarDays = $derived(splitSeminarsByDayAndTime(seminars));
</script>

<div class="seminar-list flex flex-col gap-8">
  {#if !seminarDays.length}
    <div class="px-3 py-10 bg-stone text-center copy-block w-full">
      <h3 class="m-0">No seminars found</h3>
      <p>Please try adjusting your filters.</p>
    </div>
  {/if}
  {#each seminarDays as { displayDate, times } (displayDate)}
    <div class="seminar-day">
      <div class="!mt-0 !mb-4 px-3 py-2 bg-pink text-white !text-[1.7rem] h1">{displayDate}</div>
      <div class="flex flex-col gap-4">
        {#each times as { displayTime, seminars } (`${displayDate}${displayTime}`)}
          <div class="seminar-time">
            <div class="!mt-0 !mb-2 text-pink !text-[1.5rem] h1">{displayTime}</div>
            <div class="flex flex-col gap-2">
              {#each seminars as seminar (seminar.id)}
                <SeminarTile seminar={seminar} />
              {/each}
            </div>
          </div>
        {/each}
      </div>
    </div>
  {/each}
</div>